exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mydp {\n  width: 100%;\n  border: 0 !important; }\n\n.mydp .selection {\n  border: 1px solid #ccc !important; }\n  .mydp .selection:focus {\n    outline: initial;\n    background-color: #FDF2E8;\n    border: 1px solid #FCD6A6 !important; }\n\n.icon-mydpcalendar {\n  background: url(\"/assets/img/calendar-icon.png\") no-repeat;\n  background-position: center;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: inline-block; }\n  .icon-mydpcalendar:before {\n    position: absolute;\n    content: \"\" !important; }\n\n.btnpicker {\n  background: transparent !important;\n  width: 35px !important; }\n\n.mydp .invaliddate {\n  background-color: transparent !important; }\n  .mydp .invaliddate:focus {\n    background-color: #FDF2E8 !important; }\n\n.calendar-div {\n  width: 150px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/date-picker/date-picker.component.scss
// module id = ../../../../../src/app/core/components/date-picker/date-picker.component.scss
// module chunks = main